import axios from '../helpers/axios'
import { logError } from '../services';
import { IResponse, ICustomNavigation, ICustomNavigationDetail, ICustomNavigationUpdate } from '../models';

export const getCustomNavigation = async (filters?: {
  name?: string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
}): Promise<IResponse<ICustomNavigation>> => {
  try {
    const { data } = await axios.get(`/api/custom-navigation`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getCustomNavigation failed');
    return Promise.reject(error);
  }
};

export const createCustomNavigation = async (post: ICustomNavigationUpdate): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/custom-navigation`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'createCustomNavigation failed'
    );
    return error.response.data;
  }
};

export const getCustomNavigationDetail = async (id: number | string): Promise<ICustomNavigationDetail> => {
  try {
    const { data } = await axios.get(`/api/custom-navigation/${id}`);
    return data;
  } catch (error) {
    logError(error, 'getCustomNavigationDetail failed');
    return Promise.reject(error);
  }
};

export const updateCustomNavigation = async (id: number | string, post: ICustomNavigationUpdate): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/custom-navigation/${id}`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'updateCustomNavigation failed'
    );
    return error.response.data;
  }
};

export const deleteCustomNavigation = async (id: number | string): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/custom-navigation/${id}`);
    return data;
  } catch (error) {
    logError(error, 'deleteCustomNavigation failed');
    return error.response.data;
  }
};
